import { useDispatch, useSelector } from "react-redux";
import { Col, Row } from "react-bootstrap";
import { editTaxNumber, getTaxNumber } from "store/actions";
import Loader from "components/shared/loader";
import { useNavigate } from "react-router-dom";
import SaveChangesButton from "components/Form/SaveChangesButton";
import Form from "components/Form";
import Input from "components/Form/Input";
import { useEffect } from "react";

const ViewEditProfile = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const {
    settings: { taxNumber, loading },
  } = useSelector((state) => state);

  useEffect(() => {
    dispatch(getTaxNumber());
  }, [dispatch]);

  const onSubmit = (data) => {
    dispatch(editTaxNumber({ data, navigate }));
  };
  if (loading) return <Loader />;

  return (
    <div className="acc-form">
      <div className="card">
        <div className="card-body">
          <Form onSubmit={onSubmit} defaultValues={taxNumber?.[0]}>
            <Col xl={8} md={12}>
              <Row>
                <Input name="taxNumber" />
                <SaveChangesButton />
              </Row>
            </Col>
          </Form>
        </div>
      </div>
    </div>
  );
};

export default ViewEditProfile;
